var _path;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16.824,
    height: 17.426,
    viewBox: "0 0 16.824 17.426",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "search",
    d: "M17.553,15.873l-4.148-4.314A7.033,7.033,0,1,0,8.02,14.072,6.961,6.961,0,0,0,12.051,12.8l4.179,4.346a.918.918,0,1,0,1.323-1.272ZM8.02,1.835a5.2,5.2,0,1,1-5.2,5.2A5.206,5.206,0,0,1,8.02,1.835Z",
    transform: "translate(-0.984)",
    fill: "#fff"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi44MjQiIGhlaWdodD0iMTcuNDI2IiB2aWV3Qm94PSIwIDAgMTYuODI0IDE3LjQyNiI+DQogIDxwYXRoIGlkPSJzZWFyY2giIGQ9Ik0xNy41NTMsMTUuODczbC00LjE0OC00LjMxNEE3LjAzMyw3LjAzMywwLDEsMCw4LjAyLDE0LjA3Miw2Ljk2MSw2Ljk2MSwwLDAsMCwxMi4wNTEsMTIuOGw0LjE3OSw0LjM0NmEuOTE4LjkxOCwwLDEsMCwxLjMyMy0xLjI3MlpNOC4wMiwxLjgzNWE1LjIsNS4yLDAsMSwxLTUuMiw1LjJBNS4yMDYsNS4yMDYsMCwwLDEsOC4wMiwxLjgzNVoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0wLjk4NCkiIGZpbGw9IiNmZmYiLz4NCjwvc3ZnPg0K";
export { ForwardRef as ReactComponent };